import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  PLATFORM_ID,
  ChangeDetectorRef,
  inject,
  effect,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  KEYCLOAK_EVENT_SIGNAL,
  ReadyArgs,
  KeycloakEventType,
  typeEventArgs,
} from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import {
  EmpresaService,
  ProfissaoCatalogoListItemDTO,
  Profissional,
  ProfissionalService,
  VagaService,
} from '../bolsa-de-profissionais/api';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Select } from 'primeng/select';
import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { CardPerfilComponent } from './card-perfil/card-perfil.component';
import { DashboardPowerBIComponent } from './components/dashboard-powerbi/dashboard-powerbi.component';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-dashboard',
  imports: [
    CommonModule,
    FormsModule,
    Select,
    ReactiveFormsModule,
    DrawerModule,
    AvatarModule,
    AvatarGroupModule,
    CardPerfilComponent,
    DashboardPowerBIComponent,
  ],
  providers: [ProfissionalService, EmpresaService, VagaService],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  profissionaisOption = ['USA', 'Canada', 'UK', 'Germany', 'Australia']; // Dropdown options

  selectForm = new FormGroup({
    selectedProfissional: new FormControl(''), // Default empty or set a default value
  });

  authenticated = false;
  keycloakStatus: string | undefined;
  router = inject(Router);
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);
  private readonly authStore = inject(AuthStore);
  userInfo: any = {};

  empresaService = inject(EmpresaService);
  profissionalService = inject(ProfissionalService);
  vagaService = inject(VagaService);
  profissionais: ProfissaoCatalogoListItemDTO[] = [];
  totalEmpresas: any;
  profissionaisCount: any;
  tatalVagas: any;

  perfil: any;
  profissional: Profissional | undefined | null;
  visible: boolean = false;

  //profissionaisOption: any[]=[];

  selectedProfissional: Profissional | undefined;

  constructor() {
    effect(() => {
      const keycloakEvent = this.keycloakSignal();

      this.keycloakStatus = keycloakEvent.type;

      if (keycloakEvent.type === KeycloakEventType.Ready) {
        this.authenticated = typeEventArgs<ReadyArgs>(keycloakEvent.args);
        if (this.authenticated) {
          this.loadUserData();
        }
      }

      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
        this.authenticated = false;
      }
    });
  }

  ngOnInit(): void {
    // this.getProfissionais();
    // this.getVagas();
    // this.empresaService.getAllEmpresaGet().subscribe(result => {
    //     if(result.data){
    //       this.totalEmpresas = result.records; // Calculate total users
    //     }
    // });
  }

  getProfissionais() {
    this.profissionalService.getAllProfissionalGet().subscribe((result) => {
      if (result.data) {
        this.profissionais = result.data;
        this.profissionaisCount = result.records;
      }
    });
  }

  getVagas() {
    this.vagaService.getAllVagaGet().subscribe((result) => {
      this.tatalVagas = result.records;
    });
  }

  loadUserData() {
    this.keycloak
      .loadUserInfo()
      .then((userInfo: any) => {
        this.userInfo = userInfo;
      })
      .catch(() => {
        const userInfo = this.authStore.getSessionTokenParsed();
        if (userInfo) this.userInfo = userInfo;
      });
  }

  get username() {
    if (!this.userInfo.name) {
      return '';
    }
    let fullNameArray = this.userInfo.name?.split(' ');
    return fullNameArray[0] + ' ' + fullNameArray[fullNameArray.length - 1];
  }

  get initials() {
    if (!this.username) {
      return '';
    }
    let usernameArray = this.username?.split(' ');
    return usernameArray[0].charAt(0) + usernameArray[1].charAt(0);
  }

  userPerfil(evet: any) {
    this.profissional = evet;
    this.visible = true;
  }

  submitForm() {
    console.log(
      'Profissional selecionad:',
      this.selectForm.value.selectedProfissional,
    );
  }
  /*
  data: any;

  options: any;

  platformId = inject(PLATFORM_ID);

  constructor(private cd: ChangeDetectorRef){}

  ngOnInit(): void {
    this.initChart();
  }

  initChart() {
    if (isPlatformBrowser(this.platformId)) {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--p-text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
        const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

        this.data = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [
                {
                    label: 'My First dataset',
                    backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
                    borderColor: documentStyle.getPropertyValue('--p-cyan-500'),
                    data: [65, 59, 80, 81, 56, 55, 40]
                },
                {
                    label: 'My Second dataset',
                    backgroundColor: documentStyle.getPropertyValue('--p-gray-500'),
                    borderColor: documentStyle.getPropertyValue('--p-gray-500'),
                    data: [28, 48, 40, 19, 86, 27, 90]
                }
            ]
        };

        this.options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
        this.cd.markForCheck()
    }
  }*/
}
